// extracted by mini-css-extract-plugin
export var blue = "_23-g";
export var brand = "_23-c";
export var darkGrey = "_23-f";
export var disabled = "_23-6";
export var disabledSubtle = "_23-7";
export var error = "_23-8";
export var green = "_23-h";
export var grey = "_23-e";
export var icon = "_23-0";
export var inherit = "_23-b";
export var lightGrey = "_23-d";
export var orange = "_23-j";
export var pink = "_23-l";
export var primary = "_23-1";
export var purple = "_23-m";
export var quaternary = "_23-4";
export var quinary = "_23-5";
export var red = "_23-k";
export var secondary = "_23-2";
export var success = "_23-a";
export var tertiary = "_23-3";
export var warning = "_23-9";
export var white = "_23-n";
export var yellow = "_23-i";